/**
 * Records whether the latest client-side router transition was a form mutation
 * (non-GET action). CatchPage reads this after navigation returns to idle with
 * an ErrorResponse — `useNavigation().formMethod` is already cleared by then.
 */
let lastTransitionWasMutation = false;

/**
 * Call from a mounted layout that sees every router transition (e.g. AppLayout).
 * Mutation submissions set the flag; loader soft-navs clear it.
 */
export const trackRouterTransition = (navigation: {
    state: 'idle' | 'loading' | 'submitting';
    formMethod?: string | null;
}): void => {
    if (navigation.state === 'idle') {
        return;
    }

    const method = navigation.formMethod?.toUpperCase();
    if (method && method !== 'GET') {
        lastTransitionWasMutation = true;
        return;
    }

    lastTransitionWasMutation = false;
};

/** True when the transition that produced the current route error was a form action. */
export const wasLastTransitionAMutation = (): boolean =>
    lastTransitionWasMutation;

/** Reset module state between unit tests. */
export const resetRouterTransitionOriginForTests = (): void => {
    lastTransitionWasMutation = false;
};
